<div class="row">
    <div class="col-12 col-auto">
        <div class="card">
            <div class="card-header">
                <form class="p-2" #chartForm="ngForm">
                    <div class="row">
                        <div class="col-auto">
                            <div class="input-group mb-2">
                                <button for="SelectAttributes" class="btn btn-outline-primary btn-sm">Field
                                </button>
                                <select class="form-select form-select-sm" id="SelectAttributes" name="SelectAttributes"
                                    [(ngModel)]="form.data['code']" #SelectAttributes>
                                    <option value="">--Select--</option>
                                    <option *ngFor="let e of filterAttributes()" value="{{e['code']}}">{{e["label"]}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group mb-2">
                                <button for="chartType" class="btn btn-outline-primary btn-sm">Chart
                                </button>
                                <select class="form-select form-select-sm" id="chartType" name="chartType"
                                    [(ngModel)]="form.data['chart']" #chartType>
                                    <option value="">--Select--</option>
                                    <option value="table">Table</option>
                                    <option value="line">Line</option>
                                    <option value="bar">Bar</option>
                                    <option value="pie">Pie</option>
                                     <option value="doughnut">Doughnut</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="input-group mb-2">
                                <button for="aggType" class="btn btn-outline-primary btn-sm">Type
                                </button>
                                <select class="form-select form-select-sm" id="aggType" name="aggType"
                                    [(ngModel)]="form.data['type']" #aggType>
                                    <option value="">--Select--</option>
                                    <option value="value">Value</option>
                                    <option value="range">Range</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="form-check mb-2">
                                <input class="form-check-input" type="checkbox" id="percentageCheckbox"
                                    [(ngModel)]="form.data['showPercentage']" name="showPercentage">
                                <label class="form-check-label" for="percentageCheckbox">
                                    %
                                </label>
                            </div>
                        </div>

                        <div class="col-auto">
                            <button class="btn btn-outline-primary btn-sm" (click)="drawChart()">draw
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-body">
                <div *ngIf="chartdata && this.form.data.chart!='table'" class="col col-auto">
                    <div class="container-fluid" [ngStyle]="{ 'width': chartContainerWidth, 'height': cardBodyHeight }">
                        <app-ncs-chart [ngStyle]="{ 'min-height': '300px' }" [chartType]="this.form.data.chart"
                            [data]="chartdata" [options]="chartOptions">
                        </app-ncs-chart>
                    </div>
                </div>
                <div *ngIf="chartdata && this.form.data.chart==='table'" class="col col-auto">
                    <div>
                    <app-ncs-chart-table [data]="chartdata" *ngIf="this.form.data.chart==='table'" />
                </div>
            </div>
            </div>
        </div>
    </div>
</div>